var React = require('react');
var objectAssign = require('object-assign');
module.exports = function (props) {
    return React.createElement('svg', objectAssign({}, { viewBox: '0 0 16 9' }, props), React.createElement('path', {
        strokeLinecap: 'butt',
        strokeWidth: '2',
        stroke: '#323232',
        fill: 'none',
        d: 'M 1 1 C 1 1 2.71 5 8 5 C 13.34 5 15 1 15 1 M 2.82 3.26 L 1 6 M 6.17 4.86 L 5.17 8.27 M 13.18 3.28 L 15 6 M 9.84 4.86 L 10.83 8.28'
    }));
};


//////////////////
// WEBPACK FOOTER
// ./~/react-icon-loader!./app/images/Visibility.svg
// module id = 536
// module chunks = 1